export const NEW_CREDIT_CARD_VALUE = 'new-credit-card';

export const ZUORA_SUCCESS_EVENT_KEY = 'zuora-success';
export const ZUORA_ERROR_EVENT_KEY = 'zuora-error';
export const ZUORA_CLIENT_SIDE_ERROR_EVENT_KEY = 'pajamas-client-side-zuora-error';

export const PRODUCT_OPTION_GROUP_LOADING_CLASSES = ['gl-cursor-wait'];
export const PRODUCT_OPTION_GROUP_INLINE_CLASSES = ['gl-flex', 'gl-justify-between'];

export const invoicesPath = '/invoices';

export const MAX_SEATS = 50000;
export const PurchaseDetailErrors = Object.freeze({
  MAX_SEATS_ERROR: Symbol('MAX_SEATS_ERROR'),
  INVALID_NUMBER_ERROR: Symbol('INVALID_NUMBER_ERROR'),
  MIN_SEATS_ERROR: Symbol('MIN_SEATS_ERROR'),
});

export const ADD_SEATS_TRANSACTION = 'add_seats';
export const ADD_DUO_PRO_SEATS_TRANSACTION = 'duo_pro_seats';
export const CHANGE_GITLAB_GROUP_TRANSACTION = 'change_gitlab_group';

export const MAX_SEATS_MESSAGE = `Enter a number between 1 and ${MAX_SEATS.toLocaleString('en')}.`;
export const INVALID_NUMBER_MESSAGE = `%{label} quantity is not a valid number.`;

export const I18N_SUMMARY_DATES = '%{startDate} - %{endDate}';
export const I18N_STORAGE_TOOLTIP_NOTE =
  'Your storage subscription has the same term as your main subscription, and the price is prorated accordingly.';

export const ERROR_FETCHING_PAYMENT_DETAILS_MESSAGE =
  'Could not fetch payment details. Please try again.';
export const ERROR_TOO_MANY_ADDON_SEATS_MESSAGE =
  "We couldn't complete your request, please review the highlighted errors and try again.";
